import SearchHotelWithinRadiusResult from '@app/model/flexi_sets/SearchHotelWithinRadiusResult';
import React from 'react';
import Tag from '@app/component/tag/Tag';
import Utilities from '@util/Utilities';
import FormButton from '@app/component/form/button/FormButton';

const FlexiSetMapTooltip: React.FunctionComponent<{
	hotel: SearchHotelWithinRadiusResult,
	onClose?: () => void,
	isSelected: boolean,
	onAddToSet: () => void,
	onRemoveFromSet: () => void,
}> = ({ hotel, onClose, isSelected, onAddToSet, onRemoveFromSet }) => {

	return <div className="">
		<div className="wrapper py-2 px-3 space-y-1">
			<div className="flex items-start justify-between gap-x-2">
				<div className="flex flex-col items-start">
					<p className="text-sm font-medium text-gray-900 truncate max-w-[200px]">{hotel.name}</p>
					<span
						className="block text-xs font-normal text-gray-400 truncate max-w-[200px]">{hotel.location.city}, {hotel.location.country?.name}</span>
				</div>
				<div className="flex items-start gap-x-2">
					<img className="h-9 w-9 rounded-full"
							 src={hotel.imageUrl}
							 alt={hotel.name} />
				</div>
			</div>
			<div className="flex items-center justify-between gap-x-2">
				<div className="flex flex-wrap justify-start gap-x-1 gap-y-1">
					<Tag state="gray" extraClassName="!text-[9px] !font-medium !text-gray-400">{hotel.type}</Tag>
					<Tag state="gray"
							 extraClassName="!text-[9px] !font-medium !text-gray-400">{hotel.rooms[0].numberOfBedrooms} BD</Tag>
					<Tag state="gray"
							 extraClassName="!text-[9px] !font-medium !text-gray-400">{hotel.rooms[0].numberOfBathrooms} BA</Tag>
					<Tag state="gray"
							 extraClassName="!text-[9px] !font-medium !text-gray-400">{hotel.rooms[0].numberOfBeds} Beds</Tag>
				</div>
				<a href={hotel.hotelUrl} target="_blank"
					 className="text-xs font-semibold text-gray-900 hover:text-blue-500 focus:outline-none">View
					<span className="ml-1">→</span>
				</a>
			</div>
		</div>
		<div className="wrapper py-2 px-3 space-y-1 border-y border-gray-200 bg-gray-50">
			<div className="flex flex-wrap gap-x-2 gap-y-1">
				{!isSelected &&<FormButton state='white' extraClassName='text-blue-500 text-xs py-1 px-2' onClick={onAddToSet}>Add to set</FormButton>}
				{isSelected && <FormButton state='white' extraClassName='text-red-500 text-xs py-1 px-2' onClick={onRemoveFromSet}>Remove from set</FormButton>}
			</div>
		</div>
		<div className="wrapper py-2 px-1 space-y-1">
			<h4 className="text-xs font-medium text-gray-900">Last 360 days</h4>
			<dl className="divide-y divide-gray-200 border-t border-b border-gray-200">
				<div className="flex justify-between py-1.5 text-xs font-medium">
					<dt className="text-gray-500">Typical Nightly Price</dt>
					<dd
						className="text-gray-900">{Utilities.formatAmount(hotel.statistics.average_night_rate_365, hotel.statistics.currency)}</dd>
				</div>
				<div className="flex justify-between py-1.5 text-xs font-medium">
					<dt className="text-gray-500">Open Nights (next 12 months)</dt>
					<dd
						className="text-gray-900">{Utilities.formatAmount(hotel.statistics.bookable_nights_365, hotel.statistics.currency)}</dd>
				</div>
				<div className="flex justify-between py-1.5 text-xs font-medium">
					<dt className="text-gray-500">Last‑Year Nights Sold</dt>
					<dd
						className="text-gray-900">{Utilities.formatAmount(hotel.statistics.past_booked_nights, hotel.statistics.currency)}</dd>
				</div>
				<div className="flex justify-between py-1.5 text-xs font-medium">
					<dt className="text-gray-500">Typical Booking Length</dt>
					<dd className="text-gray-900">{Utilities.formatDouble(hotel.statistics.los_365_0, 0)}</dd>
				</div>
				<div className="flex justify-between py-1.5 text-xs font-medium">
					<dt className="text-gray-500">Cleaning Fee</dt>
					<dd
						className="text-gray-900">{Utilities.formatAmount(hotel.statistics.cleaning_fee, hotel.statistics.currency)}</dd>
				</div>

			</dl>

		</div>
	</div>;
};

export default FlexiSetMapTooltip;